import { Avatar } from '@terra/ui-design-system';
import { Box } from '@terra/ui-styled-system';

type ProfileAvatarSize = 'xs' | 'sm';

type ProfileAvatarProps = {
  name: string;
  picture?: string;
  size?: ProfileAvatarSize;
};

const PROFILE_AVATAR_SIZE = {
  xs: {
    box: '6',
    avatarSize: 'xs',
    fontSize: 'xs',
  },
  sm: {
    box: '9',
    avatarSize: 'sm',
    fontSize: 'sm',
  },
} as const;

function getProfileInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return '?';
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
}

export function ProfileAvatar({
  name,
  picture,
  size = 'xs',
}: ProfileAvatarProps) {
  const sizeTokens = PROFILE_AVATAR_SIZE[size];

  if (picture) {
    return (
      <Avatar
        name={name}
        src={picture}
        size={sizeTokens.avatarSize}
        w={sizeTokens.box}
        h={sizeTokens.box}
        minW={sizeTokens.box}
        minH={sizeTokens.box}
        borderRadius="full"
      />
    );
  }

  return (
    <Box
      w={sizeTokens.box}
      h={sizeTokens.box}
      borderRadius="full"
      bg="bg.moss.subtle"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="border.moss.default"
      color="fg.moss.default"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
      fontSize={sizeTokens.fontSize}
      fontWeight="normal"
      lineHeight="none"
      userSelect="none"
    >
      {getProfileInitials(name)}
    </Box>
  );
}
